import { ReviewResponseType } from "../types/index.ts";
import { ResponseSchemaVersion } from "../types/risk-and-gap.ts";

export const getRenderType = (key: string, version?: ResponseSchemaVersion, value?: any, type?: string) => {

  if (type !== "fair" && version === "v2") {
    if (["gaps", "recommendations", "improvement_opportunities", "improvement_recommendations"].includes(key)) {
      return ReviewResponseType.LIST_OF_TEXT_WITH_SOURCE;
    }
    
    if (["observations"].includes(key.toLowerCase())) {
      return (value && Array.isArray(value)) ? ReviewResponseType.LIST_OF_COMBINED_WITH_SOURCE : ReviewResponseType.TEXT_WITH_SOURCE
    }
  }
  else if (type === "fair") {
    console.log("Version is ", key)
    if (key === "actual_risks") {
      return ReviewResponseType.TEXT_WITH_SOURCE;
    }

    if(key === "justification" || key === "recommendations"){
      return typeof value?.value === "string" ? ReviewResponseType.TEXT_WITH_SOURCE : ReviewResponseType.LIST_OF_TEXT_WITH_SINGLE_SOURCE;
    }
    
    // FAIR Assessment Controls
    if (key === "control_id") {
      switch (value) {
        case "overall risk":
          return ReviewResponseType.OVERALL_RISK;
        case "likelihood":
          return ReviewResponseType.LIKELIHOOD;
        case "threat event frequency":
          return ReviewResponseType.THREAT_EVENT_FREQUENCY;
        case "vulnerability":
          return ReviewResponseType.VULNERABILITY;
        case "threat actor capability":
          return ReviewResponseType.THREAT_ACTOR_CAPABILITY;
        case "control strength":
          return ReviewResponseType.CONTROL_STRENGTH;
        case "preventive controls":
          return ReviewResponseType.PREVENTIVE_CONTROLS;
        case "detective controls":
          return ReviewResponseType.DETECTIVE_CONTROLS;
        case "corrective controls":
          return ReviewResponseType.CORRECTIVE_CONTROLS;
        case "impact":
          return ReviewResponseType.IMPACT;
        default:
          return ReviewResponseType.TEXT;
      }
    }
  }

  if (["improvement_opportunities"].includes(key)) {
    return ReviewResponseType.LIST_OF_TEXT_WITH_SOURCE;
  }

  if (["risk_value"].includes(key)) {
    return ReviewResponseType.NUMBER;
  }

  if (["justification"].includes(key)) {
    return ReviewResponseType.TEXT_DISPLAY;
  }

  if (["compliance_status", "compliant"].includes(key)) {
    return ReviewResponseType.COMPLIANCE_STATUS;
  }

  if (["sources", "references"].includes(key)) {
    return ReviewResponseType.SOURCE;
  }

  if (["test_results"].includes(key)) {
    return ReviewResponseType.TEST_RESULTS;
  }

  if (["current_maturity_level"].includes(key)) {
    return ReviewResponseType.CURRENT_MATURITY_LEVEL;
  }

  if (["current_maturity_level_value"].includes(key)) {
    return ReviewResponseType.FLOAT_NUMBER;
  }

  return ReviewResponseType.TEXT;
};
